import { Component } from '@angular/core';
import { PageService } from '@bds/core';

@Component({
    selector: 'app-preferred-route-screen',
    template: ` <router-outlet></router-outlet>`,
})
export class PreferredRouteScreenComponent {
    constructor(private pageService: PageService) {
        this.pageService.setHeader('Preferred Routes');
    }
}

